module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: _vm.colorTheme,
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "d-flex header align-items-end justify-content-between"
  }, [_c('div', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.linkTitle) ? _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.linkName
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.viewAll($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.linkTitle)), _c('i', {
    staticClass: "icon icon-color-arrow-right"
  })])], 1) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c872338"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/TitleBlockComponent.vue
// module id = 1386
// module chunks = 1